

export default function getProducts(room, austattung_produkt, selectedAlternatives, projectLevel){

    const productList = {list:[], listPro: []};

    if(
        room.type in [
            "8142128b-51cd-47ed-8c79-7ef5b2ae83d9", //Treppenhaus
            "d8cf675b-2a77-42b9-8be7-5b9f7b6ff4f9", //Flur/Diele über 3 qm
            "46e3e159-d5a5-4623-9cd6-8f66f5fad7fa", //Kellertreppe / Flur
        ]
        && room.selectedEquipment["melden_bewegung"] !== undefined
        && Boolean(room.selectedEquipment["melden_bewegung"])
    ){
        return productList;
    }

    let countFirst = 0;
    let countAll = 0;

    const checkList = [
        {
            key: "schaltbare_beleuchtung",
            onlyFirst: false
        },
        {
            key: "dimmbare_beleuchtung",
            onlyFirst: false
        },
        {
            key: "schaltbare_steckdosen",
            onlyFirst: false
        },
        {
            key: "rolllaeden_steuern",
            onlyFirst: true
        },
        {
            key: "jalousie_steuern",
            onlyFirst: true
        }
    ];

    checkList.forEach(item => {
        if(
            room.selectedEquipment[item.key] !== undefined
            && room.selectedEquipment[item.key] > 0
        ){
            if(!item.onlyFirst) {
                countAll += room.selectedEquipment[item.key];
            }
            countFirst += room.selectedEquipment[item.key];
        }
    });

    let countForFrameFirst = 0;
    let countForFrameAll = 0;
    let countForFrameFirst_t4 = 0;
    let countForFrameAll_t4 = 0;
    const taster_list = [
        {factor: 4, key: "t4", pKeys: ["t4", room.selectedDesign.selectedSerie.zeile === '1' ? "busanakoppler" : 't4-wippe']},
        {factor: 3, key: "t3", pKeys: ["t3", room.selectedDesign.selectedSerie.zeile === '1' ? "busanakoppler" : 't3-wippe']},
    ];
    // console.log('project level', projectLevel, room.selectedDesign.selectedSerie.id)
    if (['a-1','a-8','c-1','c-8'].includes(room.selectedDesign.selectedSerie.id)) {
        if (projectLevel < 2) {
            taster_list.push({factor: 2, key: "t2", pKeys: ["t2-ba-wippe", "t2-ba"], alt: {key: "t2a", pKeys: ["t2-wippe", "t2"]} });
            taster_list.push({factor: 1, key: "t1", pKeys: ["t1-ba-wippe", "t1-ba"], alt: {key: "t1a", pKeys: ["wippe", "t1"]} });
        } else {
            taster_list.push({factor: 2, key: "t2", pKeys: ["t2-wippe", "t2"], alt: {key: "t2a", pKeys: ["t2-ba-wippe", "t2-ba"]} });
            taster_list.push({factor: 1, key: "t1", pKeys: ["wippe", "t1"], alt: {key: "t1a", pKeys: ["t1-ba-wippe", "t1-ba"]} });
        }
    } else {
        taster_list.push({factor: 2, key: "t2", pKeys: ["t2-ba-wippe", "t2-ba"], alt: {key: "t2a", pKeys: ["t2", "busanakoppler"]}});
        taster_list.push({factor: 1, key: "t1", pKeys: ["t1-ba-wippe", "t1-ba"], alt: {key: "t1a", pKeys: ["t1", "busanakoppler"]}});
    }
    // console.log('roomIn', room, 'countfirst', countFirst, )
    if(countFirst > 0){
        taster_list.forEach(taster => {
            if(
                countFirst / taster.factor >= 1
                && austattung_produkt[taster.key] !== undefined
            ){
                const c = Math.ceil(countFirst / taster.factor);
                let altList = undefined;
                let pKeysCount = 0;
                if(taster.alt !== undefined ) { // && room.selectedDesign.selectedSerie.zeile !== '2'){
                    taster.alt.pKeys.map(nk => {
                        const product = austattung_produkt[nk];
                        if (product) { pKeysCount += 1; }
                    });
                    if (pKeysCount > 1) {
                        altList = [
                            {
                                key: taster.key,
                                value: undefined,
                                products: taster.pKeys.map(nk => austattung_produkt[nk])
                            },
                            {
                                key: taster.key,
                                value: taster.alt.key,
                                products: taster.alt.pKeys.map(nk => austattung_produkt[nk])
                            }
                        ];
                    }
                }
                if(
                    selectedAlternatives !== undefined
                    && selectedAlternatives[taster.key] !== undefined
                    && !['a-1','a-8','c-1','c-8'].includes(room.selectedDesign.selectedSerie.id)
                ){
                    productList.list.push({
                        product: austattung_produkt[taster.alt.pKeys[0]],
                        count: c,
                        alt: altList
                    });
                    // productList.list.push({
                    //     product: austattung_produkt[taster.alt.pKeys[1]],
                    //     count: c
                    // });
                    productList.listPro.push({
                        product: austattung_produkt[taster.alt.pKeys[0]],
                        count: c,
                        selectedAccessories: [austattung_produkt[taster.alt.pKeys[1]]],
                    });
                }else{
                    // console.log('altList', altList)
                    if (altList !== undefined) {
                        productList.list.push({
                            product: austattung_produkt[taster.pKeys[0]],
                            count: c,
                            alt: altList
                        });
                        // console.log('pushed with alt', taster.pKeys[0], austattung_produkt[taster.pKeys[0]], altList)
                        if (selectedAlternatives === undefined || selectedAlternatives[taster.key] === undefined) {
                            productList.list.push({
                                product: austattung_produkt[taster.pKeys[1]],
                                count: c
                            });
                            // console.log('pushed with alt', taster.pKeys[1], austattung_produkt[taster.pKeys[1]])
                        }
                        productList.listPro.push({
                            product: austattung_produkt[taster.pKeys[0]],
                            count: c,
                            selectedAccessories: [austattung_produkt[taster.pKeys[1]]],
                        });
                    } else {
                        productList.list.push({
                            product: austattung_produkt[taster.pKeys[0]],
                            count: c,
                        });
                        // console.log('pushed', taster.pKeys[0], austattung_produkt[taster.pKeys[0]])
                        productList.list.push({
                            product: austattung_produkt[taster.pKeys[1]],
                            count: c
                        });
                        // console.log('pushed', taster.pKeys[1], austattung_produkt[taster.pKeys[1]])
                        productList.listPro.push({
                            product: austattung_produkt[taster.pKeys[1]],
                            count: c,
                            selectedAccessories: [austattung_produkt[taster.pKeys[0]]],
                        });
                    }
                }
                if(taster.key === "t4" && (
                    room.selectedDesign.selectedSerie.id === "s-1-e" || room.selectedDesign.selectedSerie.id === "b-3-e" ||
                    room.selectedDesign.selectedSerie.id === "b-7-e" || room.selectedDesign.selectedSerie.id === "k-1-e" ||
                    room.selectedDesign.selectedSerie.id === "k-5-e")){
                    countForFrameFirst_t4 += c;
                }else {
                    countForFrameFirst += c;
                }
                countFirst -= c * taster.factor;
            }
        });
    }
    if(countAll > 0){
        taster_list.forEach(taster => {
            if(
                (room.doorCount - 1) > 0
                && countAll / taster.factor >= 1
                && austattung_produkt[taster.key] !== undefined
            ){
                const c = Math.ceil(countAll / taster.factor);
                let altList = undefined;
                if(taster.alt !== undefined && room.selectedDesign.selectedSerie.zeile !== '2'){
                    altList = [
                        {
                            key: taster.key,
                            value: undefined,
                            products: taster.pKeys.map(nk => austattung_produkt[nk])
                        },
                        {
                            key: taster.key,
                            value: taster.alt.key,
                            products: taster.alt.pKeys.map(nk => austattung_produkt[nk])
                        }
                    ];
                }
                if(
                    selectedAlternatives !== undefined
                    && selectedAlternatives[taster.key] !== undefined
                ){
                    productList.list.push({
                        product: austattung_produkt[taster.alt.pKeys[0]],
                        count: c * (room.doorCount - 1),
                        alt: altList
                    });
                    productList.list.push({
                        product: austattung_produkt[taster.alt.pKeys[1]],
                        count: c * (room.doorCount - 1)
                    });
                    productList.listPro.push({
                        product: austattung_produkt[taster.alt.pKeys[0]],
                        count: c * (room.doorCount - 1),
                        selectedAccessories: [austattung_produkt[taster.alt.pKeys[1]]],
                    });
                }else{
                    productList.list.push({
                        product: austattung_produkt[taster.pKeys[0]],
                        count: c * (room.doorCount - 1),
                        alt: altList
                    });
                    productList.list.push({
                        product: austattung_produkt[taster.pKeys[1]],
                        count: c * (room.doorCount - 1)
                    });
                    productList.listPro.push({
                        product: austattung_produkt[taster.pKeys[0]],
                        count: c * (room.doorCount - 1),
                        selectedAccessories: [austattung_produkt[taster.pKeys[1]]],
                    });
                }
                if(taster.key === "t4" && (
                    room.selectedDesign.selectedSerie.id === "s-1-e" || room.selectedDesign.selectedSerie.id === "b-3-e" ||
                    room.selectedDesign.selectedSerie.id === "b-7-e" || room.selectedDesign.selectedSerie.id === "k-1-e" ||
                    room.selectedDesign.selectedSerie.id === "k-5-e")){
                    countForFrameAll_t4 += c;
                }else {
                    countForFrameAll += c;
                }
                countAll -= c * taster.factor;
            }
        });
    }
    [{count: countForFrameFirst, factor: 1}, {count: countForFrameAll, factor: (room.doorCount -1)}].forEach(countObj => {
        let innerCount = countObj.count;
        [
            {factor: 5, key: "r-5f"},
            {factor: 4, key: "r-4f"},
            {factor: 3, key: "r-3f"},
            {factor: 2, key: "r-2f"},
            {factor: 1, key: "r-1f"}
        ].forEach(frame => {
            if(
                innerCount / frame.factor >= 1
                && austattung_produkt[frame.key] !== undefined
            ){
                const c = Math.ceil(innerCount / frame.factor);
                productList.list.push({
                    product: austattung_produkt[frame.key],
                    count: c * countObj.factor
                });
                productList.listPro.push({
                    product: austattung_produkt[frame.key],
                    count: c * countObj.factor,
                    selectedAccessories: [],
                });
                innerCount -= c * frame.factor;
            }
        });
    });

    if(countForFrameFirst_t4 > 0){
        productList.list.push({
            product: austattung_produkt["s-r1f"],
            count: countForFrameFirst_t4
        })
        productList.listPro.push({
            product: austattung_produkt["s-r1f"],
            count: countForFrameFirst_t4,
            selectedAccessories: [],
        });
    }
    if(countForFrameAll_t4 > 0){
        productList.list.push({
            product: austattung_produkt["s-r1f"],
            count: countForFrameFirst_t4 * (room.doorCount -1)
        })
        productList.listPro.push({
            product: austattung_produkt["s-r1f"],
            count: countForFrameFirst_t4 * (room.doorCount -1),
            selectedAccessories: [],
        });
    }


    return productList;
}
